import React, { useContext } from "react";
import "./singlestyles.scss";
import { EleveType } from "../../../../types/GlobalType";
import { eleveContext } from "../../../../context/AppContext";
import moment from "moment";

const EleveInfo = () => {
  const eleveData: EleveType = useContext(eleveContext);
  console.log(eleveData);
  return (
    <div className="tuteur_info">
      <h4 className="title_section">Information Elève</h4>
      <table>
        <tr>
          <td>Nom:</td>
          <td>{eleveData.nom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Post-Nom:</td>
          <td>{eleveData.postnom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Prénom:</td>
          <td>{eleveData.prenom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Classe:</td>
          <td>{eleveData.classe_designation?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Date de naissance:</td>
          <td>
            {eleveData.lieu_naissance?.toUpperCase()},{" "}
            {moment(eleveData.date_naissance).format("DD-MM-YYYY")}
          </td>
        </tr>
      </table>
      <h4 className="title_section_2">Adresse résidentielle</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>{eleveData.avenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{eleveData.quartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{eleveData.commune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{eleveData.ville?.toUpperCase()}</td>
        </tr>
      </table>
    </div>
  );
};

export default EleveInfo;
